/* eslint-disable no-fallthrough */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import lod_ from "lodash";
import { useSelector } from "react-redux";
import TabAction from "helpers/TabAction";
import { Box, Card, Divider } from "@material-ui/core";
import ConversationAction from "./ConversationAction";
import AnalyseDocumentLlmModal from "../ConvActions/AnalyseDocumentLlm";
import ForwardMessage from "../Message/components/ForwardMessage";
import GenerateAnswerReply from "../ConvActions/GenerateAnswerReply";
import {
	isAutoSendConversationEligible,
	isAutoSendForwardAction
} from "helpers/actions/business/autoSendForward";

/**
 *
 */
export const ActionsComponent = ({
	rcvAttAll,
	sntAttAll,
	popoverCloseMenu,
	popoverActionsHandleClose,
	props
}) => {
	const { sortedBuiltInAnswers } = useSelector(state => state.answers);
	const { selectedConversation, isCockpitArchived } = useSelector(state => state.cockpit);
	const { selectedAssistantID, assistantconfig } = useSelector(state => state);
	const { userStatus } = useSelector(state => state);

	const [conversationActions, setConversationActions] = useState([]);
	const [longActions, setLongActions] = useState([]);

	const [actionModal, setActionModal] = useState({
		code: "",
		open: false,
		data: {}
	});

	/**
	 * Handle action result when user clicks on an "view result" in action
	 * @param {*} data
	 */
	const handleActionResult = data => {
		setActionModal({
			code: data.code,
			open: true,
			data: data
		});
	};

	const closeModal = () => {
		setActionModal({
			code: "",
			open: false,
			data: {}
		});
	};

	const getOpenModal = code => {
		return actionModal.code === code && actionModal.open;
	};

	const getModalData = code => {
		return actionModal.code === code ? actionModal.data : {};
	};

	const getAnalyseOpenModal = code => {
		return actionModal?.data?.name === code && actionModal.open;
	};

	const getAnalyseModalData = code => {
		return actionModal?.data?.name === code ? actionModal.data : {};
	};

	useEffect(() => {
		if (assistantconfig?.actions) {
			let conversationActions = assistantconfig.actions.filter(e => e.scope === "conversation");
			if (!lod_.isEmpty(conversationActions)) {
				const actionsSorted = lod_.sortBy(conversationActions, ["rank"]);
				setConversationActions(actionsSorted);
			}
		}
	}, [assistantconfig.actions, selectedAssistantID]);

	useEffect(() => {
		if (selectedConversation.actions) {
			let actions = lod_.cloneDeep(selectedConversation.actions);
			setLongActions(actions.reverse() ?? []);
		}
	}, [selectedConversation.actions, selectedAssistantID]);

	return (
		<>
			<Card
				style={{
					padding: 10,
					minWidth: "30vw"
				}}
			>
				{/* Actions in progress */}
				{!lod_.isEmpty(longActions) &&
					longActions.map((action, index) => {
						return (
							<ConversationAction
								key={index}
								action={action}
								onResult={data => {
									handleActionResult(data);
									popoverActionsHandleClose();
								}}
							/>
						);
					})}
				{!lod_.isEmpty(longActions) && (
					<Box mt={3} mb={3}>
						<Divider />
					</Box>
				)}
				{/* Display actions */}
				{!lod_.isEmpty(conversationActions) &&
					conversationActions.map(action => {
						// If user is in cockpitArchived tab, display only filtered actions
						if (isCockpitArchived && !action?.filter?.archived) {
							return;
						}
						if (!isCockpitArchived && action?.filter?.archivedOnly) {
							return;
						}

						// Check if action is valid for the channel
						if (
							action.valid_for_channel_code &&
							!action.valid_for_channel_code.includes(selectedConversation.header.channel)
						) {
							return;
						}

						// The auto send forward forwards the first message, only when it is the only one, not answered yet
						if (
							isAutoSendForwardAction(action) &&
							!isAutoSendConversationEligible(selectedConversation)
						) {
							return;
						}

						/**
						 * Gestion of name with new format action front v2
						 * Get language of profile to get correct action name or default to english or first available
						 */
						const language = userStatus?.auth?.user?.language?.toUpperCase();
						let nameOfAction = action.name;
						if (!lod_.isNil(action.actionName) && !lod_.isEmpty(action.actionName)) {
							if (!lod_.isNil(language) && !lod_.isNil(action.actionName[language])) {
								nameOfAction = action.actionName[language];
							} else {
								nameOfAction =
									action.actionName.EN ?? Object.values(action.actionName)[0] ?? action.name;
							}
						}

						return (
							<TabAction
								key={`${action.name}-${action.index}`}
								name={nameOfAction}
								multipleAction={action.multipleAction}
								selectedConversation={selectedConversation}
								logo={action.logo ?? action.logoURL}
								// action={action.action}
								code={action.code}
								events={action.events}
								rcvAttAll={rcvAttAll}
								sntAttAll={sntAttAll}
								builtInAnswers={sortedBuiltInAnswers}
								queryParams={action.queryParams}
								actionObject={action}
								popoverCloseMenu={popoverCloseMenu}
								popoverActionsHandleClose={popoverActionsHandleClose}
							/>
						);
					})}
			</Card>
			{/* Reply assistant action */}
			<GenerateAnswerReply
				data={getModalData("replyAssistant")}
				open={getOpenModal("replyAssistant")}
				onClose={closeModal}
			/>
			{/* Analyse document LLM action */}
			<AnalyseDocumentLlmModal
				data={getModalData("analyseDocumentLlm")}
				open={getOpenModal("analyseDocumentLlm")}
				onClose={closeModal}
			/>

			{/* Analyse message LLM action */}
			<ForwardMessage
				data={getAnalyseModalData("forwardMessageToConv")}
				open={getAnalyseOpenModal("forwardMessageToConv")}
				handleClose={closeModal}
			/>
		</>
	);
};
